<script setup lang="ts">
import { nextTick } from 'vue'

import { useSearchStore } from '@shared/global-store/stores/search'
import { t } from '@storefront-satch/lib/translations'

import { SearchIcon } from '@fond-of/satch-icons'

const emits = defineEmits<{
  updateMobileNav: []
}>()

const searchStore = useSearchStore()

const focusInput = () => {
  nextTick(() => {
    const input = document.getElementById('navigation-search-input')
    input?.focus()
  })
}
</script>

<template>
  <button
    :class="[
      'group/search-toggle inline-flex cursor-pointer items-center justify-center',
      'lg:p-3.75 gap-1.5 pl-0 pr-0 md:gap-2.5 lg:ml-[5px] lg:pr-0',
    ]"
    type="button"
    data-label="search toggle button"
    @click="
      () => {
        searchStore.toggleOpenState()
        focusInput()

        emits('updateMobileNav')
      }
    "
  >
    <SearchIcon class="md:size-4.5 size-5.5 cursor-pointer" />
    <span class="hidden text-center font-sans text-[15px] text-black lg:block">
      {{ t('navigation.search.placeholder') }}
    </span>
  </button>
</template>
